import type { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Alert, Flex, Text, Tooltip, UnstyledButton } from "src/components";
import { BorderRadius, Color, FontSize } from "src/theme";
import type { OutageType } from "src/types";
import { CATEGORY_TITLE } from "../constants";
import { TooltipContent } from "./TooltipContent";

export type AnnotationItemProps = {
    outageType: OutageType;
    isActive: boolean;
    onClick: (outageType: OutageType) => void;
};

export const AnnotationItem: FC<AnnotationItemProps> = ({ outageType, isActive, onClick }) => {
    const { t } = useTranslation();

    return (
        <Tooltip content={<TooltipContent category={outageType} active={isActive} />}>
            <Button backgroundColor={Color.green} active={isActive} onClick={() => onClick(outageType)}>
                <Flex alignItems="center" gap="0.5em">
                    <Alert type={outageType} />
                    <Text size={FontSize._14}>{t(CATEGORY_TITLE[outageType])}</Text>
                </Flex>
            </Button>
        </Tooltip>
    );
};

const Button = styled(UnstyledButton)<{ active: boolean; backgroundColor: Color }>`
    border: ${({ theme, active }) => active && `1px solid ${theme.color.gray50}`};
    padding: 0.5rem 1rem;
    border-radius: ${BorderRadius._5};
    background-color: ${({ backgroundColor, active }) => active && `${backgroundColor}1D`};
`;
